module.exports = __webpack_public_path__ + "img/project3.3cdf9891.jpg";